export function colorByState(state: string) {
    switch (state) {
      case "Need to Review":
        return "warning";
      case "Reviewed":
        return "success";
      case "Request supplement":
        return "danger";
      default:
        return "";
    }
  }